export const SELECT_INFLATION = "SELECT_INFLATION";
export const RESET_INFLATION = "RESET_INFLATION";
